import { graphql } from "msw";
import { CustomerQuery } from "@catchoftheday/common-vendors";

export const mockCustomer: CustomerQuery["customer"] = {
  __typename: "Customer" as const,
  id: "1234",
  displayName: "Joe",
  club: {
    __typename: "ClubCustomerSubscription" as const,
    active: false,
    freeTrialEligible: true,
    onFreeTrial: false,
  },
  email: "joe@catch.com.au",
  membership: {
    id: "1",
    linked: true,
    doubleSubscription: false,
    eligibleForMigration: false,
    subscription: {
      active: false,
      freeTrialEligible: false,
      freeTrialDaysRemaining: 30,
      onFreeTrial: false,
    },
  },
  metaData: {
    customerUuid: "e2e51708-588c-41da-8e2a-b8b2de8ac62e",
  },
};

export const handler = graphql.query<CustomerQuery>(
  "Customer",
  (_req, res, ctx) => {
    return res(
      ctx.data({
        customer: mockCustomer,
      })
    );
  }
);
